import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  ref: "tableWrapper",
  class: "p-p-2 child-content"
}
const _hoisted_2 = { class: "column-cell" }
const _hoisted_3 = { class: "p-fluid p-formgrid p-grid p-input-filled" }
const _hoisted_4 = { class: "p-field p-col-12" }
const _hoisted_5 = { for: "translationKey" }
const _hoisted_6 = {
  key: 2,
  class: "p-error"
}
const _hoisted_7 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_DialogDelete = _resolveComponent("DialogDelete")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_EntryDialog = _resolveComponent("EntryDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_DataTable, {
        value: _ctx.translationRows,
        loading: _ctx.loadingTranslations,
        class: "p-datatable-sm translation-table",
        paginator: true,
        filters: _ctx.filters,
        "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters) = $event)),
        filterDisplay: "row",
        paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
        rowsPerPageOptions: [25,50,100],
        first: _ctx.firstRow,
        rows: _ctx.rowsPerPage,
        rowClass: _ctx.rowClass,
        columnResizeMode: "fit",
        currentPageReportTemplate: '{first} ' + _ctx.$t('Squeeze.General.To') + ' {last} ' + _ctx.$t('Squeeze.General.Of') + ' {totalRecords} ',
        scrollable: true,
        scrollHeight: "flex",
        autoLayout: true,
        onRowDblclick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openEditDialog($event.data))),
        onPage: _ctx.onPage
      }, {
        loading: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.General.Loading')), 1)
        ]),
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.General.NoEntriesFound', { entryName: _ctx.$t('Squeeze.System.Translations') })), 1)
        ]),
        paginatorstart: _withCtx(() => [
          (!_ctx.disabledNewEntryButton)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                label: _ctx.$t('Squeeze.General.NewEntry'),
                type: "button",
                icon: "mdi mdi-plus",
                class: "p-button",
                disabled: _ctx.availableTranslationKeys.length === 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openCreateDialog()))
              }, null, 8, ["label", "disabled"]))
            : _createCommentVNode("", true)
        ]),
        paginatorend: _withCtx(() => [...(_cache[6] || (_cache[6] = []))]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "translationKey",
            filterField: "translationKey",
            header: _ctx.$t('Squeeze.System.TranslationKey'),
            showFilterMenu: false
          }, {
            filter: _withCtx(({filterModel, filterCallback}) => [
              _createVNode(_component_InputText, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                type: "text",
                class: "p-column-filter filter-field",
                style: {"min-width":"100%"},
                onInput: ($event: any) => (filterCallback())
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
            ]),
            _: 1
          }, 8, ["header"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeLanguageOptions, (languageColumn) => {
            return (_openBlock(), _createBlock(_component_Column, {
              key: languageColumn.countryCode,
              field: 'translations.' + languageColumn.countryCode,
              filterField: 'translations.' + languageColumn.countryCode,
              header: languageColumn.translatedDescription,
              showFilterMenu: false,
              style: {"min-width":"14rem"}
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.getTranslationValue(slotProps.data, languageColumn.countryCode)), 1)
              ]),
              filter: _withCtx(({filterModel, filterCallback}) => [
                _createVNode(_component_InputText, {
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  type: "text",
                  class: "p-column-filter filter-field",
                  style: {"min-width":"100%"},
                  onInput: ($event: any) => (filterCallback())
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
              ]),
              _: 2
            }, 1032, ["field", "filterField", "header"]))
          }), 128)),
          _createVNode(_component_Column, {
            style: {"min-width":"5.6rem"},
            frozen: "",
            alignFrozen: "right"
          }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.hasStoredTranslations)
                ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "mdi mdi-pencil-outline",
                    class: "p-button-lg p-button-rounded p-button-success p-button-text",
                    onClick: _withModifiers(($event: any) => (_ctx.openEditDialog(slotProps.data)), ["stop"])
                  }, null, 8, ["onClick"])), [
                    [
                      _directive_tooltip,
                      _ctx.$t('Squeeze.Locators.Edit'),
                      void 0,
                      { bottom: true }
                    ]
                  ])
                : _createCommentVNode("", true),
              (slotProps.data.hasStoredTranslations)
                ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    icon: "mdi mdi-delete-outline",
                    class: "p-button-lg p-button-rounded p-button-danger p-button-text",
                    onClick: _withModifiers(($event: any) => (_ctx.openDeleteDialog(slotProps.data)), ["stop"])
                  }, null, 8, ["onClick"])), [
                    [
                      _directive_tooltip,
                      _ctx.$t('Squeeze.Validation.Buttons.Delete'),
                      void 0,
                      { bottom: true }
                    ]
                  ])
                : _createCommentVNode("", true),
              (!slotProps.data.hasStoredTranslations)
                ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                    key: 2,
                    icon: "mdi mdi-plus",
                    class: "p-button-lg p-button-rounded p-button-success p-button-text",
                    onClick: _withModifiers(($event: any) => (_ctx.openCreateDialog(slotProps.data)), ["stop"])
                  }, null, 8, ["onClick"])), [
                    [
                      _directive_tooltip,
                      _ctx.$t('Squeeze.General.NewEntry'),
                      void 0,
                      { bottom: true }
                    ]
                  ])
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "loading", "filters", "first", "rows", "rowClass", "currentPageReportTemplate", "onPage"])
    ], 512),
    _createVNode(_component_DialogDelete, {
      showDialog: _ctx.deleteDialog,
      onOnClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteDialog = false)),
      onOnConfirm: _ctx.deleteTranslation
    }, null, 8, ["showDialog", "onOnConfirm"]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.showEditDialog,
      onOnClose: _ctx.closeEditDialog,
      onOnConfirm: _ctx.saveTranslation,
      loading: _ctx.loadingDialog,
      width: '80rem',
      headerText: _ctx.dialogHeaderText,
      showKeepDialogOpen: false
    }, {
      content: _withCtx(() => [
        _createVNode(_component_BlockUI, { blocked: _ctx.loadingDialog }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('Squeeze.System.TranslationKey')) + " *", 1),
                (_ctx.isEditMode)
                  ? (_openBlock(), _createBlock(_component_InputText, {
                      key: 0,
                      id: "translationKey",
                      modelValue: _ctx.translationEntry.translationKey,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.translationEntry.translationKey) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"]))
                  : (_openBlock(), _createBlock(_component_Dropdown, {
                      key: 1,
                      id: "translationKey",
                      modelValue: _ctx.translationEntry.translationKey,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.translationEntry.translationKey) = $event)),
                      options: _ctx.availableTranslationKeys,
                      filter: true,
                      autoFilterFocus: true,
                      optionValue: "translationKey",
                      optionLabel: "translationKey",
                      class: _normalizeClass({'p-invalid': _ctx.isTranslationKeyInvalid && _ctx.showValidationMessage})
                    }, null, 8, ["modelValue", "options", "class"])),
                (_ctx.isTranslationKeyInvalid && _ctx.showValidationMessage)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.System.TranslationKey') })), 1))
                  : _createCommentVNode("", true)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeLanguageOptions, (language) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: language.countryCode,
                  class: "p-field p-col-12 p-md-6"
                }, [
                  _createElementVNode("label", {
                    for: 'translation-' + language.countryCode
                  }, _toDisplayString(language.translatedDescription), 9, _hoisted_7),
                  _createVNode(_component_InputText, {
                    id: 'translation-' + language.countryCode,
                    modelValue: _ctx.translationEntry.translations[language.countryCode],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.translationEntry.translations[language.countryCode]) = $event)
                  }, null, 8, ["id", "modelValue", "onUpdate:modelValue"])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["blocked"])
      ]),
      _: 1
    }, 8, ["show", "onOnClose", "onOnConfirm", "loading", "headerText"])
  ], 64))
}